'use client';

import { c as _c } from "react/compiler-runtime";
import { convictionPercent } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Icon } from '@/components/ui/icon';
import { ChampionIconSolid, Target02IconSolid, UserGroup03IconSolid } from '@/components/ui/icon/glyphs';
import { useFormattedCurrency } from '@/lib/currency';
import { formatCompactNumber } from '@/lib/format/format-number';
export function StackedMarketCardMeta(t0) {
  const $ = _c(56);
  const {
    consensusThreshold,
    prizePoolD6,
    uniqueTradersTotal: t1
  } = t0;
  const uniqueTradersTotal = t1 === undefined ? 0 : t1;
  const tRow = useTranslations("market.row");
  const tFeatured = useTranslations("markets.featured");
  const {
    formatD6
  } = useFormattedCurrency();
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let traders;
  if ($[0] !== consensusThreshold || $[1] !== formatD6 || $[2] !== prizePoolD6 || $[3] !== tFeatured || $[4] !== tRow || $[5] !== uniqueTradersTotal) {
    const thresholdLabel = consensusThreshold === null ? tRow("threshold_loading") : `${String(Math.round(convictionPercent(consensusThreshold)))}%`;
    const prizePool = formatD6(prizePoolD6, "compactTight");
    let t12;
    if ($[17] !== uniqueTradersTotal) {
      t12 = Math.round(uniqueTradersTotal);
      $[17] = uniqueTradersTotal;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    traders = formatCompactNumber(Math.max(0, t12), 0);
    t6 = "pointer-events-none flex min-w-0 items-center gap-2 text-caption text-foreground-tertiary";
    t7 = "stacked-market-card-meta";
    let t13;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Icon icon={Target02IconSolid} className="size-icon-xs" aria-hidden="true" />;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    const t14 = tRow("resolves_at", {
      value: thresholdLabel
    });
    let t15;
    if ($[20] !== t14) {
      t15 = <span className="sr-only">{t14}</span>;
      $[20] = t14;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[22] !== thresholdLabel) {
      t16 = <span aria-hidden="true" className="tabular-nums">{thresholdLabel}</span>;
      $[22] = thresholdLabel;
      $[23] = t16;
    } else {
      t16 = $[23];
    }
    if ($[24] !== t15 || $[25] !== t16) {
      t8 = <span className="inline-flex min-w-0 items-center gap-1">{t13}{t15}{t16}</span>;
      $[24] = t15;
      $[25] = t16;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <span aria-hidden="true">·</span>;
      $[27] = t9;
    } else {
      t9 = $[27];
    }
    let t17;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Icon icon={ChampionIconSolid} className="size-icon-xs" aria-hidden="true" />;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    const t18 = tFeatured("meta_prize_pool", {
      amount: prizePool
    });
    let t19;
    if ($[29] !== t18) {
      t19 = <span className="sr-only">{t18}</span>;
      $[29] = t18;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    let t20;
    if ($[31] !== prizePool) {
      t20 = <span aria-hidden="true" className="truncate tabular-nums">{prizePool}</span>;
      $[31] = prizePool;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    if ($[33] !== t19 || $[34] !== t20) {
      t10 = <span className="inline-flex min-w-0 items-center gap-1">{t17}{t19}{t20}</span>;
      $[33] = t19;
      $[34] = t20;
      $[35] = t10;
    } else {
      t10 = $[35];
    }
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <span aria-hidden="true">·</span>;
      $[36] = t11;
    } else {
      t11 = $[36];
    }
    t4 = "inline-flex items-center gap-1";
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Icon icon={UserGroup03IconSolid} className="size-icon-xs" aria-hidden="true" />;
      $[37] = t5;
    } else {
      t5 = $[37];
    }
    t2 = "sr-only";
    t3 = tFeatured("meta_traders", {
      count: traders
    });
    $[0] = consensusThreshold;
    $[1] = formatD6;
    $[2] = prizePoolD6;
    $[3] = tFeatured;
    $[4] = tRow;
    $[5] = uniqueTradersTotal;
    $[6] = t10;
    $[7] = t11;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = traders;
  } else {
    t10 = $[6];
    t11 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
    traders = $[16];
  }
  let t12;
  if ($[38] !== t2 || $[39] !== t3) {
    t12 = <span className={t2}>{t3}</span>;
    $[38] = t2;
    $[39] = t3;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== traders) {
    t13 = <span aria-hidden="true" className="tabular-nums">{traders}</span>;
    $[41] = traders;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t12 || $[44] !== t13 || $[45] !== t4 || $[46] !== t5) {
    t14 = <span className={t4}>{t5}{t12}{t13}</span>;
    $[43] = t12;
    $[44] = t13;
    $[45] = t4;
    $[46] = t5;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t14 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
    t15 = <p className={t6} data-testid={t7}>{t8}{t9}{t10}{t11}{t14}</p>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t14;
    $[51] = t6;
    $[52] = t7;
    $[53] = t8;
    $[54] = t9;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  return t15;
}